import React from 'react';
import Factory from '@leverege/factory';
import { DefaultResult, LowBattery, Offline, Unactivated } from './resultRenderers';
export default new Factory({
  registry: {
    [LowBattery.TYPE]: LowBattery,
    [Unactivated.TYPE]: Unactivated,
    [Offline.TYPE]: Offline
  },
  strategy: Factory.reactStrategy(React),
  defaultObject: DefaultResult
});